import {Game} from '@js/utils/Game';

export class EasterEgg {

  constructor() {
    this.password()
  }

  password() {
    const secretCode = ['s', 'i', 'm', 'u'];
    let userInput = [];

    document.addEventListener('keydown', (event) => {
      userInput.push(event.key.toLowerCase());
      if (userInput.length > secretCode.length) {
        userInput.shift();
      }
      if (userInput.join('') === secretCode.join('')) {
        this.showDialog()
      }
    });
  }

  showDialog() {

    if (!document.getElementById('game')) {
      const dialog = document.createElement('dialog');
      dialog.id = 'game';
      const dialogContent = `
                    <canvas id="game-canvas" width="800" height="800"></canvas>
                    <div id="startScreen">
                        <button id="startButton"><span>Démarrer le jeu</span></button>
                    </div>
                    <div id="gameOverScreen">
                        <h2>Un drame est arrivé..</h2>
                        <p id="finalScore"></p>
                        <button id="restartButton"><span>Rejouer</span></button>
                    </div>
                `;
      dialog.innerHTML = dialogContent;
      document.body.appendChild(dialog);
      const game = new Game("game-canvas");
    }

    const dialog = document.getElementById('game');
    if (dialog) dialog.showModal()
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  }


}
